interface AddressItemProps {
  icon: string;
  title: string;
  value: string | number;
  className?: string;
}

const addressData = [
  {
    icon: 'icon-namecall',
    title: 'تلفن',
    value: '66402031',
  },
  {
    icon: 'icon-nameLocation',
    title: 'آدرس',
    value:
      'تهران، میدان انقلاب، کوی برهانی، حسینعلی‌پور، پارک علم و فناوری دانشگاه تهران، پلاک 1، واحد 202،',
  },
  {
    icon: 'icon-nameemail-sendng',
    title: 'کد پستی',
    value: '1417933133',
  },
];

export const AddressItem = ({
  icon,
  title,
  value,
  className = 'grid grid-cols-[auto,1fr] gap-4',
}: AddressItemProps) => {
  return (
    <div className={className}>
      <div className="flex items-start gap-1 text-sm text-gray-700 min-w-[150px]">
        <i className={`text-lg ${icon}`} />
        <span>{title}</span>
      </div>
      <span className="text-sm break-words">{value}</span>
    </div>
  );
};

const CompanyAddressData = () => {
  return (
    <div className="w-full">
      <span className="block mb-1 text-sm ">
        ارسال اصل چک <span className="text-red-600">*</span>
      </span>
      <span className="mb-1 text-sm">
        برای ادامه فعالیت, شما باید اصل چک را ارسال کنید.
      </span>
      <div className="flex flex-col gap-3 p-[1rem] mt-2 rounded-lg bg-gray-50">
        {addressData.map((item, index) => (
          <AddressItem
            key={index}
            icon={item.icon}
            title={item.title}
            value={item.value}
          />
        ))}
      </div>
    </div>
  );
};

export default CompanyAddressData;
